
<div class="site-panel w-100" v-if="tzb" style="position: relative">
    <p-site-tzb-history
        :unit     = "site"
        :current  = "tzb"
        :history  = "history.items"
        v-model   = "history.show"
        @selected = "onSelected"
    />

    <p-site-tzb-reports
        v-model   = "reports.show"
        :menu     = "reports.items"
        @selected = "onPrint"
    />

    <div v-if="!readonly && !latest" class="pl-3 pt-2 orange--text text--darken-4 font-weight-medium">
        {{ $t('unit.escalator.tzb.readonly') }}
    </div>

    <v-row class="no-frame">
        <v-col class="main-first-col no-border">
            <v-row class="no-frame mt-2">
                <c-site-tzb-escalator-general
                    :data     = "tzb"
                    :editable = "editable"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-escalator-maintenance
                    :data     = "tzb.maintenance"
                    :editable = "editable"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-escalator-gadget
                    :title      = "$t('unit.escalator.tzb.steps')"
                    :gadget     = "tzb.steps"
                    :editable   = "editable"
                />
            </v-row>
            <c-v-spacer />
        </v-col>
        <v-col class="main-middlle-col no-border">
            <v-row class="no-frame mt-2">
                <c-site-tzb-escalator-gadget
                    :title      = "$t('unit.escalator.tzb.drive')"
                    :type-label = "$t('unit.escalator.tzb.driveType')"
                    :gadget     = "tzb.drive"
                    :editable   = "editable"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-escalator-gadget
                    :title      = "$t('unit.escalator.tzb.automatic')"
                    :type-label = "$t('unit.escalator.tzb.automaticType')"
                    :gadget     = "tzb.automatic"
                    :editable   = "editable"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-escalator-gadget
                    :title      = "$t('unit.escalator.tzb.control')"
                    :type-label = "$t('unit.escalator.tzb.controlType')"
                    :gadget     = "tzb.control"
                    :editable   = "editable"
                />
            </v-row>
            <c-v-spacer />
        </v-col>
        <v-col class="main-middlle-col no-border">
            <v-row class="no-frame mt-2">
                <c-site-tzb-escalator-gadget
                    :title    = "$t('unit.escalator.tzb.handrails')"
                    :gadget   = "tzb.handrails"
                    :editable = "editable"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-escalator-gadget
                    :title    = "$t('unit.escalator.tzb.balustrade')"
                    :gadget   = "tzb.balustrade"
                    :editable = "editable"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-escalator-gadget
                    :title    = "$t('unit.escalator.tzb.combs')"
                    :gadget   = "tzb.combs"
                    :editable = "editable"
                />
            </v-row>
            <c-v-spacer />
        </v-col>
        <v-col class="main-last-col no-border">
            <v-row class="no-frame mt-2">
                <c-site-tzb-escalator-gadget
                    :title    = "$t('unit.escalator.tzb.socle')"
                    :gadget   = "tzb.socle"
                    :editable = "editable"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-escalator-gadget
                    :title    = "$t('unit.escalator.tzb.socleBrushes')"
                    :gadget   = "tzb.socleBrushes"
                    :editable = "editable"
                />
            </v-row>
            <c-v-spacer />
        </v-col>
    </v-row>
</div>
